import axios, { AxiosResponse } from "axios";
import { IGlobalDateFilter } from "../../models/filters/IFilters";
import { IFlightSummaryResponse } from "../../models/flights/IFlightSummary";
import { AIRPORT_CODE_PARAMETER } from "../../utils/common/Constants";
import { buildFlightSummaryPayload } from "../../utils/flights/FlightSummaryApi";

export default class FlightSummaryService {
  public getFlightSummary = async (
    accessToken: string,
    airportCode: string,
    globalFilterDate: IGlobalDateFilter,
    timezone: string
  ): Promise<AxiosResponse<IFlightSummaryResponse[]>> => {
    const headers = {
      "x-api-key": process.env.REACT_APP_APIM_KEY,
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json;charset=UTF-8",
    };

    const payload = buildFlightSummaryPayload(
      airportCode,
      globalFilterDate.startDate,
      globalFilterDate.endDate,
      "Best",
      timezone
    );

    return axios.post<IFlightSummaryResponse[]>(
      `${process.env.REACT_APP_API_FLIGHTSUMMARY?.replace(
        AIRPORT_CODE_PARAMETER,
        airportCode
      )}`,
      JSON.stringify(payload),
      { headers }
    );
  };
}
